/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChefEntrepriseSelectorGridDto } from './ChefEntrepriseSelectorGridDto';
import {
    ChefEntrepriseSelectorGridDtoFromJSON,
    ChefEntrepriseSelectorGridDtoFromJSONTyped,
    ChefEntrepriseSelectorGridDtoToJSON,
} from './ChefEntrepriseSelectorGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface ChefEntrepriseSelectorGridDtoPaginatedResults
 */
export interface ChefEntrepriseSelectorGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ChefEntrepriseSelectorGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ChefEntrepriseSelectorGridDto>}
     * @memberof ChefEntrepriseSelectorGridDtoPaginatedResults
     */
    results?: Array<ChefEntrepriseSelectorGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ChefEntrepriseSelectorGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ChefEntrepriseSelectorGridDtoPaginatedResults interface.
 */
export function instanceOfChefEntrepriseSelectorGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChefEntrepriseSelectorGridDtoPaginatedResultsFromJSON(json: any): ChefEntrepriseSelectorGridDtoPaginatedResults {
    return ChefEntrepriseSelectorGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ChefEntrepriseSelectorGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChefEntrepriseSelectorGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ChefEntrepriseSelectorGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ChefEntrepriseSelectorGridDtoPaginatedResultsToJSON(value?: ChefEntrepriseSelectorGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ChefEntrepriseSelectorGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

